module.exports = __webpack_public_path__ + "static/media/ebips-logo.6519aa4b.svg";